module.exports = __webpack_public_path__ + "img/sub-successful.60720df4.gif";